// extracted by mini-css-extract-plugin
export default {"select":"style_select__ywGys","option":"style_option__E7iIZ"};